module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-douwe-egberts-bottom-01.1.fb4fd744.jpg";